import React from "react";
import OmniHeroesBack from "../back";
import './index.scss'
import OmniHeroesClose from "../close";
import { FormattedMessage } from "react-intl";
export default class TopicHeader extends React.Component {
    render() {
        return (
            <div className="detail-header">
                <div>
                    <OmniHeroesBack isDark type="detail" />
                    <span className="title">
                         <FormattedMessage id="detail"></FormattedMessage>
                    </span>
                    <OmniHeroesClose isDark />
                </div>
            </div>
        )
    }
}